export default __webpack_public_path__ + "static/media/patent03-1.15a3555b.png";